import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import type { PortService } from "@services/port-services/types";
import { useTranslation } from "react-i18next";

type UploadDocumentButtonProps = {
  portServiceDetails: PortService;
  openUploadDocumentDrawer: (drawerInfo: PortService) => void;
};
const LANG_BASE = "vessel-call.port-services.preview";

const UploadDocumentButton = ({
  portServiceDetails,
  openUploadDocumentDrawer,
}: UploadDocumentButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="contained"
      color="primary"
      testId={`${LANG_BASE}-upload-documents-button`}
      label={
        <span className="text-sm font-medium flex items-center gap-2">
          <AddCircleOutlineIcon fontSize="small" />
          {t(`${LANG_BASE}.upload-document`)}
        </span>
      }
      sx={{
        textTransform: "none",
        height: "40px",
        minHeight: "40px",
      }}
      onClick={() => openUploadDocumentDrawer(portServiceDetails)}
    />
  );
};
export default UploadDocumentButton;
